import {useParams} from "react-router-dom";
import React from "react";
import {Spinner} from "../../../shared";
import {useSelector} from "react-redux";
import './episodeDetails.css';
import '../serieDetails/serieDetails.scss';
import {useIntl} from "react-intl";
import users from "../../../users";
import {Helmet} from "react-helmet";
import OverviewCardV2 from "../../overviewCardV2/overviewCardV2";
import useEpisodeDetailsData from "../../hooks/useEpisodeDetailsData";


function EpisodeDetails({squadflixTvHook}) {

    const intl = useIntl();
    const darkMode = useSelector(users.selectors.isDarkMode)
    const {serieId, seasonNumber, episodeNumber} = useParams();
    const {
        serie,
        episode,
        episodeItem,
        nextEpisode,
        goToNextEpisode,
        loading
    } = useEpisodeDetailsData(serieId, seasonNumber, episodeNumber, squadflixTvHook);

    if (loading) {
        return (
            <center className="mt-4">
                <Spinner></Spinner>
            </center>
        )
    }

    const tagline = intl.formatMessage({id: 'tmdb-item-details.aired-date'}, {date: new Date(episode.air_date).toLocaleDateString()}) + ' - ' + episode.runtime + 'min';

    return (
        <div>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>{serie.name} - S{episode.season_number + ""}:E{episode.episode_number + ""}</title>
                <link rel="icon"
                      href="https://torresowo.myftp.org/web/cap17an/cap17drive/imagenes/Icono-Cap17Drive.png"/>
            </Helmet>

            <div style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: darkMode ? "black" : "white",
                zIndex: 12,
            }}>
                <OverviewCardV2 view={episode.view}
                                item={episodeItem}
                                itemName={episode.name}
                                overview={episode.overview}
                                imagePath={episode.still_path}
                                playing={true}
                                file={episode.shared_files[0]}
                                type="tv"
                                squadFlixTvHook={squadflixTvHook}
                                tmdbId={serieId}
                                season={episode.season_number}
                                episode={episode.episode_number}
                                nextEpisode={nextEpisode}
                                onGoNextEpisode={goToNextEpisode}
                                tagline={tagline}/>
            </div>
        </div>
    )
}

export default EpisodeDetails;
